import React from 'react'

import Skeleton from 'react-loading-skeleton'
import AdCardListItem from '../../../../../features/components/AdCardListItem'
import FacebookAdPreviewSkeleton from '../../../../../features/components/FacebookPreviews/reusablePreviewComponents/FacebookAdPreviewSkeleton'
import SkeletonInternalAdActionButtons from '../../../../AdApprovals/AdsSection/InternalAdActionButtons/Skeleton'
import SkeletonAdCardDetails from '../../../../../features/components/AdCardListItem/AdCardDetails/Skeleton'
import AdCardMetrics from '../../../../../features/components/AdCardListItem/AdCardMetrics'
import AdCardMetricSkeleton from '../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/AdCardMetricSkeleton'

import useStyles from './styles'
import usePreviewStyles, { adApprovalsPreviewMinHeight, adPreviewMinHeight } from './AdCardPreview/styles'

function SkeletonFacebookAdCardListItem({
  showStatus = true,
  showDetails = true,
  showMetrics = true,
  showActionsButtons = false,
  isAdApprovalsStyle = false
}) {
  const classes = useStyles()
  const previewClasses = usePreviewStyles({ isAdApprovalsStyle })

  return (
    <AdCardListItem>
      <div className={classes.cardHeader}>
        {showStatus && (
          <div className={classes.statusChip} style={{ width: 62 }}>
            <Skeleton />
          </div>
        )}
      </div>
      <div
        className={previewClasses.adPreviewWrapper}
        style={{ height: isAdApprovalsStyle ? adApprovalsPreviewMinHeight : adPreviewMinHeight }}
      >
        <FacebookAdPreviewSkeleton className={previewClasses.scaledAdPreview} />
      </div>
      {showDetails && <SkeletonAdCardDetails />}
      {showMetrics && (
        <AdCardMetrics>
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
        </AdCardMetrics>
      )}
      {showActionsButtons && <SkeletonInternalAdActionButtons />}
    </AdCardListItem>
  )
}

export default SkeletonFacebookAdCardListItem
